import { Client, ClientStatus } from "@/types/types";


  // Helper function to safely get status text for translation
export  const getStatusText = (status: ClientStatus | string | undefined): string => {
    if (!status) return "active";
    return status.toLowerCase();
  };

  /**
   * Statut affiché d'un abonnement.
   *
   * Les tests portaient sur `paused` / `sessionsTotal` / `sessionsRemaining`
   * (camelCase) alors que les appelants passent des lignes DB en snake_case
   * (`is_paused`, `sessions_total`, `sessions_remaining`) : un abonnement en
   * pause ou à 0 séance s'affichait « active ». On accepte les deux formes.
   */
  export  const getStatusTextFromSubscription = (subscription: any): string => {
    if (!subscription) return "active";

    const isPaused = subscription.is_paused ?? subscription.isPaused ?? subscription.paused;
    if (isPaused) return "paused";

    const sessionsTotal = subscription.sessions_total ?? subscription.sessionsTotal ?? 0;
    const sessionsRemaining = subscription.sessions_remaining ?? subscription.sessionsRemaining ?? 0;
    if (sessionsTotal > 0 && sessionsRemaining <= 0) return "expired";

    // `status` peut être absent sur une ligne partielle : `.toLowerCase()` sur
    // `undefined` levait en plein rendu de la table.
    return String(subscription.status ?? "active").toLowerCase();
  };

/**
 * Date « Membre depuis » : la date de début du PREMIER abonnement (min), et
 * non celle de l'abonnement courant — un adhérent renouvelé restait sinon
 * affiché comme membre depuis son dernier renouvellement.
 * Replis : `startDate` de l'abonnement courant, puis rien.
 */
export const getMemberSinceDate = (client: {
  startDate?: string;
  subscriptionHistory?: Array<{ start_date?: string | null; startDate?: string | null }> | null;
}): string | undefined => {
  const dates = (client.subscriptionHistory ?? [])
    .map((s) => (s?.start_date ?? s?.startDate ?? null))
    .filter((d): d is string => typeof d === 'string' && d.trim() !== '');

  if (client.startDate) dates.push(client.startDate);
  if (dates.length === 0) return undefined;

  return dates.reduce((min, d) => (new Date(d) < new Date(min) ? d : min));
};
